// test2867
(2867 && 0);
